export default __webpack_public_path__ + "static/media/05.ef098955.jpg";